import FollowControl from "./FollowControl";

export { default as useFollowControl } from "./use_follow_control";
export default FollowControl;
